import styled from 'styled-components';

import { colors } from '@/constants/theme';

export const Component = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  cursor: grab;

  display: grid;
  grid-template-columns: auto auto;
  column-gap: 8px;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;

  border-radius: 100%;

  background: linear-gradient(180deg, ${colors.white} 0%, #dceaff 100%);
  box-shadow: 0 2px 3px rgba(0, 24, 57, 0.2);
`;

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;
